import PropTypes from 'prop-types';
import React, { useEffect, useState, memo } from 'react';
import { animated, useSpring } from 'react-spring';
import paths from './flag-paths.json';
import './Flag.scss';

const AnimatedFlagSVG = props => {
	const { path, className } = props;
	const animatedPath = useSpring({
		d: path,
		config: {
			duration: 1000
		},
	});

	return (
		<svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 171.14 86.6" version="1.0">
			<animated.path className="flag-image" d={animatedPath.d} />
		</svg>
	);
}

export const Flag = memo(props => {
	const { className } = props;
	const [currentPathIndex, setCurrentPathIndex] = useState(0);
	const [timer, setTimer] = useState(null);
	const [animationKey, setAnimationKey] = useState(false);
	const currentPath = paths[currentPathIndex];

	// Increase index of the current frame or start from 0
	// Also when start from 0, update key to rerender (remount) AnimatedFlagSVG component
	const updatePath = (currentPathIndex) => {
		const nextPathIndex = currentPathIndex + 1;
		if (nextPathIndex < paths.length) {
			setCurrentPathIndex(nextPathIndex);
		}
		else {
			setCurrentPathIndex(0);
			setAnimationKey(animationKey => !animationKey);
			setTimeout(() => updatePath(1));
		}
	}

	// Timer to switch between frames (SVG paths)
	useEffect(() => {
		clearTimeout(timer);
		const newTimer = setTimeout(() => {
			updatePath(currentPathIndex);
		}, 1000);
		setTimer(newTimer);
	}, [currentPathIndex]);

	return <AnimatedFlagSVG className={className} path={currentPath} key={animationKey} />
});

Flag.propsTypes = {
	className: PropTypes.string
};
